package me.repeater64.advancedmpkeditor.backend.data_object.trigger_items

abstract class BookItem(open val pages: List<String>) : TriggerItem